import React from 'react';

import { updateBreadcrumbs } from '~src/spacesPlatform/actions/UpdateBreadcrumbsAction';
import { BreadcrumbStateInfo } from '~src/spacesPlatform/components/breadcrumbs/BreadcrumbStateInfo';
import { ConnectedSpaceInfoProvider } from '~src/spacesPlatform/components/Explorer/helpers/SpaceInfoProvider';
import { SpacesSiteUrls } from '~src/spacesPlatform/components/spaceComponents/SpacesSiteUrls';
import { SpaceInfo, SpaceItemForNonEntitySpace } from '~src/spacesPlatform/state/SpaceInfo';

import { getAppStore } from '../../../../bootstrap/redux/store/AppStore';
import { ConnectedQueryParamUpdateProvider } from '../../../../bootstrap/routerHelpers/QueryParamUpdateProvider';
import { Messages } from '../../../../codegen/Localize';
import { ConnectedAllGroupsSpace } from './ConnectedAllGroupsSpace';

export interface AllGroupsSpaceProviderProps {
  readonly siteName: string;
  readonly routeLocationPath: string;
  readonly routeLocationSearch: string;
  readonly urls: SpacesSiteUrls;
}

const groupsSpaceInfo: SpaceInfo = { spaceType: 'groups', subspaceName: undefined, item: SpaceItemForNonEntitySpace };

export const AllGroupsSpaceProvider: React.FunctionComponent<AllGroupsSpaceProviderProps> = (props) => {

  React.useEffect(
    () => {
      getAppStore().dispatch(updateBreadcrumbs([getGroupsPlaceBreadcrumb(props.urls)]));
    },
    // This deps array was noncompliant before we enabled the lint rule. If you’re here, please consider fixing it! See TFS 1257824
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  return (
    <ConnectedSpaceInfoProvider spaceInfo={groupsSpaceInfo}>
      <ConnectedQueryParamUpdateProvider
        routeLocationPath={props.routeLocationPath}
        routeLocationSearch={props.routeLocationSearch}
        shouldUpdateBreadcrumbs={true}
        shouldUpdateContentTypes={false}
        shouldUpdateFilters={true}
        shouldUpdateSort={true}
      >
        <ConnectedAllGroupsSpace
          siteName={props.siteName}
        />
      </ConnectedQueryParamUpdateProvider>
    </ConnectedSpaceInfoProvider>
  );
};

export function getGroupsPlaceBreadcrumb(urls: SpacesSiteUrls): BreadcrumbStateInfo {
  const href = urls.groupsUrl();
  return {
    id: href,
    text: Messages.allGroups(),
    href: href,
    testId: 'groups-link'
  };
}
